import { render, staticRenderFns } from "./NoFeedback.vue?vue&type=template&id=0acaa838&"
import script from "./NoFeedback.vue?vue&type=script&lang=js&"
export * from "./NoFeedback.vue?vue&type=script&lang=js&"
import style0 from "./NoFeedback.vue?vue&type=style&index=0&id=0acaa838&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports